import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import { Theme } from '../theme';
var maxValue = 1;

var Bar = function Bar(_ref) {
  var isIndeterminate = _ref.isIndeterminate,
      tokens = _ref.tokens;

  if (isIndeterminate) {
    return jsx(React.Fragment, null, jsx("span", {
      css: [tokens.bar, tokens.increasingBar]
    }), jsx("span", {
      css: [tokens.bar, tokens.decreasingBar]
    }));
  }

  return jsx("span", {
    css: [tokens.bar, tokens.determinateBar]
  });
};

var ProgressBar = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ProgressBar, _React$PureComponent);

  var _super = _createSuper(ProgressBar);

  function ProgressBar() {
    _classCallCheck(this, ProgressBar);

    return _super.apply(this, arguments);
  }

  _createClass(ProgressBar, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value,
          isIndeterminate = _this$props.isIndeterminate,
          theme = _this$props.theme;
      var valueParsed = isIndeterminate ? 0 : Math.max(0, Math.min(value, maxValue));
      return jsx(Theme.Provider, {
        value: theme
      }, jsx(Theme.Consumer, {
        value: value
      }, function (tokens) {
        return jsx("div", {
          css: tokens.container,
          role: "progressbar",
          "aria-valuemin": 0,
          "aria-valuenow": valueParsed,
          "aria-valuemax": maxValue,
          tabIndex: 0
        }, jsx(Bar, {
          isIndeterminate: isIndeterminate,
          tokens: tokens
        }));
      }));
    }
  }]);

  return ProgressBar;
}(React.PureComponent);

_defineProperty(ProgressBar, "defaultProps", {
  value: 0,
  isIndeterminate: false
});

export { ProgressBar as default };